import { useMemo } from "react";
import { useEffect } from "react";
import SelectingBoatButton from "../../components/select-vessel-button";
import AddInvoiceButton from "./add-invoice-button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { addDays } from "date-fns";
import { cn, formatDate, parseDateParam } from "@/lib/utils";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Mixpanel } from "@/lib/mixpanel";
import { useHasPermission } from "@/hooks/use-permission";
import { PERMISSIONS } from "@/lib/constants/permissions";

const Header = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchDate = searchParams.get("date");
  const canWriteExpenses = useHasPermission(PERMISSIONS.Expenses.Write);

  const date = useMemo(() => parseDateParam(searchDate), [searchDate]);

  useEffect(() => {
    if (!searchParams.has("date")) {
      setSearchParams({ date: formatDate(new Date(), "yyyy-MM-dd") });
    }
  }, [searchParams, setSearchParams]);

  const handleDateChange = (increment: number) => {
    setSearchParams((prev) => {
      const newDate = addDays(parseDateParam(prev.get("date")), increment);
      prev.set("date", formatDate(newDate, "yyyy-MM-dd"));
      return prev;
    });
  };
  return (
    <div className="flex flex-col items-center justify-center px-5">
      <div className="flex w-full flex-row items-center justify-between gap-2">
        <SelectingBoatButton />
        {canWriteExpenses && <AddInvoiceButton defaultDate={date} />}
      </div>

      <div className="mt-[15px] flex w-full flex-col items-center justify-center">
        <button
          data-testid="calendar-button"
          onClick={() => {
            navigate("/invoices/monthly");
            Mixpanel.track("Navigate to Monthly");
          }}
          className={cn(
            "invoice-calendar-button flex w-full items-center justify-between rounded-md border border-y-white/10 border-l-[#406f7e] border-r-[#63919f] text-left font-normal shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)]",
            !date && "text-muted-foreground"
          )}
        >
          <div
            data-testid="previous-date-button"
            role="button"
            onClick={(e) => {
              e.stopPropagation();
              handleDateChange(-1);
              Mixpanel.track("Previous Date Button Clicked");
            }}
            className="flex h-9 items-center justify-start px-2 text-start text-white/65 transition-all duration-200 hover:bg-transparent hover:text-white"
          >
            <CaretLeft />
          </div>
          <span
            data-testid="selected-date-value"
            className="p-[10px] text-base font-medium leading-4 text-white"
          >
            {formatDate(date, "PPP, iii")}
          </span>

          <div
            data-testid="next-date-button"
            role="button"
            onClick={(e) => {
              e.stopPropagation();
              handleDateChange(1);
              Mixpanel.track("Next Date Button Clicked");
            }}
            className="flex h-9 items-center justify-end px-2 text-white/65 transition-all duration-200 hover:bg-transparent hover:text-white"
          >
            <CaretRight />
          </div>
        </button>
      </div>
    </div>
  );
};

export default Header;
